import React from 'react';

import { ContainerWrapper, ItemWrapper } from './GridStyles';
import { conditionalClassNames } from '../../UtilityComponents/Util';
import * as gridProps from './gridProps';

const Grid = ({
    container=false,
    item=false,
    spacing,
    xs=false,
    sm=false,
    md=false,
    lg=false,
    xl=false,
    justify,
    alignContent,
    alignItems,
    direction,
    wrap,
    itemClass,
    containerClass,
    children,
}) => {
    const itemClasses = conditionalClassNames('gridItem', {
        [`biz-col-xs-${xs === true ? 'auto' : xs}`]: !!xs,
        [`biz-col-sm-${sm === true ? 'auto' : sm}`]: !!sm,
        [`biz-col-md-${md === true ? 'auto' : md}`]: !!md,
        [`biz-col-lg-${lg === true ? 'auto' : lg}`]: !!lg,
        [`biz-col-xl-${xl === true ? 'auto' : xl}`]: !!xl,
        [itemClass]: !!itemClass,
    });
    return (
        <>
            {
                !!container && (
                    <ContainerWrapper
                        justify={justify}
                        alignContent={alignContent}
                        alignItems={alignItems}
                        $direction={direction}
                        wrap={wrap}
                        spacing={spacing}
                        className={containerClass}
                    >
                        {children}
                    </ContainerWrapper>
                )
            }
            {
                !!item && !container && (
                    <ItemWrapper
                        className={itemClasses}
                    >
                        {children}
                    </ItemWrapper>
                )
            }
        </>
    )
}

Grid.propTypes = {
    xs: gridProps.deviceTypeArr,
    sm: gridProps.deviceTypeArr,
    md: gridProps.deviceTypeArr,
    lg: gridProps.deviceTypeArr,
    xl: gridProps.deviceTypeArr,
    justify: gridProps.justify,
    alignContent: gridProps.alignContent,
    alignItems: gridProps.alignItems,
    wrap: gridProps.wrap,
    children: gridProps.children,
    direction: gridProps.direction,
    containerClass: gridProps.containerClass,
    itemClass: gridProps.itemClass,
    container: gridProps.container,
    item: gridProps.item,
    spacing: gridProps.spacing,
}

export default Grid;
